module.exports = __webpack_public_path__ + "static/img/123_TO8_1668_og.54d15be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/123_TO8_1668_og.jpg
// module id = YtR7
// module chunks = 0